module.exports = __webpack_public_path__ + "static/media/img_0318.c7ec5306.jpeg";